import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { SDialogButton } from './BCommonComponents';
import React from 'react';

export interface ConfirmDialogProps {
	open: boolean;
	onClose: () => void;
	message: string;
}

export interface alertDialogSetter {
	setShowAlert: React.Dispatch<React.SetStateAction<boolean>>,
	setAlertMessage: React.Dispatch<React.SetStateAction<string>>
}
export const AlertDialogContext = React.createContext<alertDialogSetter>({ setShowAlert: () => {
	console.log('settato show');
	}, setAlertMessage: () => {} });

export const AlertDialog = (props: ConfirmDialogProps) => {
	const {open, onClose, message} = props;

	const handleClose = () => {
		onClose();
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"ATTENZIONE"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<SDialogButton onClick={handleClose}>
						OK
					</SDialogButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
